const schema = {
  title: 'Task',
  type: 'object',
  properties: {
    due_date: { 
      type: ['string', 'null'],
      format:'date',
      isNotEmpty: true,
      isNotNull: true,
    },
    booklet: { 
      type: 'string',
      maxLength: 50,
      isNotEmpty: true
    },
    note: {
      type: 'string',
    },
    parent_patient: {
      type: 'string'
    },
    task_owner: {
      type: 'string'
    },
    done: {
      type: ['string', 'null'],
      format:'date'
    }
  },
  required: ['booklet', 'due_date']
}

export default schema
